var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dashboard-new"
  }, [_c('div', {
    staticClass: "header-new"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row align-item-center"
  }, [_c('div', {
    staticClass: "col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 left-section"
  }, [_c('div', {
    staticClass: "d-flex align-item-center"
  }, [_c('div', {
    staticClass: "main-logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DashboardNew'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo-new-cor.png"),
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "user-title ml-3"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(" Welcome "), _c('strong', {
    staticStyle: {
      "color": "whitesmoke"
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))])]), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Member Dashboard")])])])]), _c('div', {
    staticClass: "col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 right-section"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-item-center"
  }, [_c('div', {
    staticClass: " login-status"
  }, [_c('ul', {
    staticClass: "list-unstyled mb-0"
  }, [_c('li', [_c('p', [_c('span', [_vm._v("IP Address: ")]), _vm._v(_vm._s(_vm.user.ip))])]), _c('li', [_c('p', [_vm._v(" Last login: "), _c('span', [_vm._v(_vm._s(_vm.user.last_login))])])])])]), _c('div', {
    staticClass: "top-user ml-3"
  }, [_c('ul', {
    staticClass: "list-unstyled mb-0"
  }, [_c('li', {
    staticClass: "top-user-dropdown"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.image || '/img/default_profile.52292c62.jpg',
      "alt": "profile"
    }
  }), _c('span', {
    staticClass: "header-user-name"
  }, [_vm._v(" " + _vm._s(_vm.user.name))]), _c('b-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.changePassword",
      modifiers: {
        "changePassword": true
      }
    }],
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Change Password")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.changeEmail",
      modifiers: {
        "changeEmail": true
      }
    }],
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Change Login Email")]), _c('b-dropdown-divider'), _c('b-dropdown-item', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function click($event) {
        return _vm.logout();
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-sign-out-alt fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "height": "20px",
      "fill": "currentColor",
      "data-prefix": "fas",
      "data-icon": "sign-out-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    }
  })]), _vm._v(" Logout ")]), _c('b-dropdown-divider', {
    staticClass: "responsive-view-only"
  }), _c('b-dropdown-item', {
    staticClass: "responsive-view-only",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('p', [_c('span', [_vm._v("IP Address: ")]), _vm._v(_vm._s(_vm.user.ip) + " ")])]), _c('b-dropdown-item', {
    staticClass: "responsive-view-only",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('p', [_vm._v(" Last login: "), _c('span', [_vm._v(_vm._s(_vm.user.last_login))])])])], 1)], 1)])])])])])])]), _c('change-email-modal'), _c('change-password-modal'), _c('SideNav')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }